import React from 'react';

import Buttons from './Buttons';
import Popovers from './Popovers';
import RangeInputs from './RangeInputs';
import SelectFields from './SelectFields';
import Surveys from './Surveys';
import Swatches from './Swatches';
import Tables from './Tables';
import TextFields from './TextFields';
import Typography from './Typography';

import FeatureSeatics from './FeatureSeatics';

export default (props) => (
  <div>
    <Swatches onChangeTheme={props.onChangeTheme} />
    <Typography />
    <Buttons />
    <Tables />
    <RangeInputs />
    <SelectFields />
    <TextFields />
    <Popovers />
    <Surveys />
    <FeatureSeatics />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/demo/Stickersheet.js